import React from "react";
import { Link, useLocation } from "react-router-dom";
import ProfileDropdown from './ProfileDropdown';
import logo from "../../assets/img/logos/logo-no-background.png";
import CustomLink from "./CustomLink";
import MobileMenu from "./MobileMenu";
import { jwtDecode } from "jwt-decode";

const Links = [
    {
        name: "PhysioScope",
        url: "/auth/physioscope",
    },
    {
        name: "CellScope",
        url: "/auth/cellscope",
    },
    {
        name: "BatteryScope-P",
        url: "/batteryscope",
    },
    {
        name: "BatteryScope-C",
        url: "/batteryscope-c",
    },
];

const isUserLoggedIn = () => {
    try {
        const token = localStorage.getItem("token");
        if (token === null) return false;
        return token ? true : false;
    }
    catch (error) {
        return false;
    }
}


const Navbar = () => {
    const { pathname } = useLocation();
    return (
        <nav className="bg-[black] p-4 md:px-10 flex justify-between items-center fixed top-0 w-full z-10">
            {isUserLoggedIn() && (
                <MobileMenu links={Links} />
            )}
            <Link to="/auth/physioscope" className="text-white text-lg font-bold">
                <img src={logo} alt="logo" className="h-8 md:h-10" />
            </Link>
            {isUserLoggedIn() && (
                <ul className="hidden md:flex space-x-4">
                    {Links.map((link, index) => (
                        <li key={index}>
                            <CustomLink
                                name={link.name}
                                url={link.url}
                                isActive={pathname === link.url}
                            />
                        </li>
                    ))}
                </ul>
            )}
            {isUserLoggedIn() && (
                <ProfileDropdown />
            )}
        </nav>
    );
};

export default Navbar;
